import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from "./PageSection";
import classes from "./OneColumnPageSection.module.scss";
export default function OneColumnPageSection(_a) {
    var { title, children } = _a, props = __rest(_a, ["title", "children"]);
    return (_jsx(PageSection, Object.assign({}, props, { children: _jsxs("div", { className: classes.container, children: [title && _jsx("h1", { className: classes.title, children: title }), _jsx("div", { className: classes.content, children: children })] }) })));
}
